export default "__VITE_ASSET__fcda05f6__"